import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import * as FormikControls from './index';

class FormikRadio extends FormikControls.Input {

    render() {

        const { label, id, } = this.props;

        
        return (
            <FormikControls.Input  {...this.props}>
                <label dangerouslySetInnerHTML={{ __html: label }} htmlFor={id} />
            </FormikControls.Input>);
    }

}

FormikRadio.defaultProps = {
    className: 'radio checkbox',
    type: 'radio'
};

export default FormikRadio;